import type { FC } from 'react'

import { t, tm, TM, type LString } from '@web-solutions/module-localization';
import { tKey } from '@web-solutions/core/summary/special-offer/constants';
import { Text } from '@web-solutions/core/ui-elements';
import type { ProductDetails } from '@web-solutions/core/store/billing/selectors';

import classes from './style.module.scss'

export interface ProductItemProps {
  activeProduct: ProductDetails,
  currentPriceText?: LString
}

export const ProductItem: FC<ProductItemProps> = ({ activeProduct, currentPriceText }) => (
  <div className={classes.wrapper}>
    <div className={classes.label} >
      <span className={classes.text}>
        {t(`${tKey}.no_funds.product_label`)}
      </span>
    </div>
    {activeProduct.textLineThrough &&
      <Text className={classes.prevPrice}>
        {tm(activeProduct.textLineThrough, '', activeProduct)}
      </Text>
    }
    <Text className={classes.currentPrice}>
      <TM k={currentPriceText} defaultKey={`${tKey}.no_funds.product_text`} tOptions={activeProduct} />
    </Text>
  </div>
)